import $http from '../../axios'
import {Notification} from "element-ui";

export async function searchProducts ({state,commit}, filter) {
    let params ={
        filter : filter,
        paginate : false,
        branchoffice_id: localStorage.selected_branchoffice,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
    }
    await $http.get('/api/lista-productos', {params}).then((response) => {
        commit("setProducts", response.data.data.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}
export async function searchProductsEquivalents ({state,commit}, product_id) {
    state.loading.module = true
    await $http.get('/api/productos-equivalentes?product_id='+product_id).then((response) => {
        state.loading.module = false
        commit("setProductsEquivalent", response.data.data);
    }).catch(error => {
        state.loading.module = false
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}
export async function addProductsEquivalents ({state,commit,dispatch}, product_id) {
    let data = state.params
    data.product_id = product_id
    state.loading.module = true
    await $http.post('/api/productos-equivalentes', data)
        .then((response) => {
            state.loading.module = false
            state.params.product_equivalent_id = null;
            dispatch('searchProductsEquivalents', product_id);
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            state.loading.module = false
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}
export async function deleteProductsEquivalents ({state,commit}, row) {
    state.loading.module = true
    await $http.delete(`/api/productos-equivalentes?product_id=${row.product_id}&product_equivalent_id=${row.product_equivalent_id}`)
        .then((response) => {
            state.loading.module = false
            commit("setProductsEquivalent", response.data.data);
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            state.loading.module = false
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/products_equivalent/actions.js